export enum PurchaseOrigin {
  PRIVATE_SALE = 'PRIVATE_SALE',
}

export type ProductPurchaseOrigin = PurchaseOrigin | string;
